const History = {
  _history: [], // 历史记录堆栈
  install(Vue) {
    // 提供Vue插件所需安装方法
    Object.defineProperty(Vue.prototype, '$routerHistory', {
      get() {
        return History
      }
    })
  },
  curPath: '',
  push(path) { // 入栈
    this._history.push(path)
  },
  pop() {
    this._history.pop()
  },
  canBack() {
    return this._history.length > 1
  },
  goList() {
    return this._history
  },
  getCurFullPath() {
    if (this._history.length === 0) {
      return ''
    }
    return this._history[this._history.length - 1]
  },
  getPrevFullPath() {
    if (this._history.length < 2) {
      return ''
    }
    return this._history[this._history.length - 2]
  }
}
export default History

